// extracted by mini-css-extract-plugin
export default {"container":"CreatePopupBase_container__7fJJu"};